import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Transformation } from './components/sections/Transformation';
import { SoundsLikeYou } from './components/sections/SoundsLikeYou';
import { Included } from './components/sections/Included';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCTA } from './components/sections/FinalCTA';
export function App() {
  return <div className="w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="23vuq4hqc94x9">
      <MetaPixel data-id="element-1" data-mp="23t8iki3g6pf1" />
      <Hero data-id="element-2" data-mp="3ijxqiu0iq6lh" />
      <main data-id="element-3" data-mp="3ik7k0rkruvvx">
        <Transformation data-id="element-4" data-mp="3ikr0e3urxc7u" />
        <SoundsLikeYou data-id="element-5" data-mp="3ijfwm41bw4gq" />
        <Included data-id="element-6" data-mp="3ihv0wb3a2fha" />
        <Volumes data-id="element-7" data-mp="3mlj8uuvtnd32" />
        <Bonuses data-id="element-8" data-mp="3ml1234bj9ggw" />
        <Offer data-id="element-9" data-mp="3mkhnnxl3da7m" />
        <Guarantee data-id="element-10" data-mp="3mjzu58ptda3e" />
        <Testimonials data-id="element-11" data-mp="3mjg8pi0yg3km" />
        <About data-id="element-12" data-mp="3rcj6y3gog175" />
        <Faq data-id="element-13" data-mp="3rbzn2h7gv2qh" />
        <FinalCTA data-id="element-14" data-mp="3rdar8i4tqci4" />
      </main>
      <footer className="w-full bg-navy-950 px-4 pb-28 pt-10 text-center sm:px-6" data-id="element-15" data-mp="3rd17vdeab3le">
        <p className="font-display text-base font-bold tracking-[0.28em] text-gold-400" data-id="element-16" data-mp="5ggje8nxyxz">
          DR. KARITO
        </p>
        <p className="mx-auto mt-3 max-w-md text-[12px] leading-relaxed text-white/45" data-id="element-17" data-mp="2zn6cp03qwjot">
          © 2026 Dr. Karito — Clinical Master System™ for Dental Diagnosis. All Rights Reserved.
        </p>
      </footer>
      <PurchasePopup data-id="element-18" data-mp="38o4ct7b2c724" />
      <FloatingCTA data-id="element-19" data-mp="3dle28mygcipy" />
    </div>;
}